import { Css } from "@homebound/beam";
import { Icon } from "src/components/Icon";
import { PersonalDashboard_TaskFragment } from "src/fragments/circularFragments.generated";
import { NamedFragment } from "src/fragments/commonFragments.generated";
import { TaskParentTag } from "../../components/TaskParentTag";

type ScheduleTaskRowDataProps = { task: PersonalDashboard_TaskFragment; onTaskSelect: (taskId: string) => void };

export function TaskRowIcon({ task }: Omit<ScheduleTaskRowDataProps, "onTaskSelect">) {
  const { isGlobalMilestoneTask, isCriticalPath } = task;

  if (!isGlobalMilestoneTask && !isCriticalPath) return null;

  return (
    <>
      {isGlobalMilestoneTask ? (
        <div data-testid="milestoneIcon" css={Css.p1.bgBlue100.br4.$}>
          <Icon icon="diamond" />
        </div>
      ) : (
        <div data-testid="criticalPath" css={Css.p1.$}>
          <Icon icon="criticalPath" color="#646464" />
        </div>
      )}
    </>
  );
}

export function TaskTitleAndParent({ task, onTaskSelect }: ScheduleTaskRowDataProps) {
  return (
    <div data-testid="taskTitleAndParent">
      <div
        data-testid="taskTitle"
        css={Css.sm.pb1.blue700.cursorPointer.onHover.tdu.$}
        onClick={() => onTaskSelect(task.id)}
      >
        {task.name}
      </div>
      <TaskParentTag taskParent={task.project as NamedFragment} />
    </div>
  );
}
